import React from 'react';
import { Button } from 'antd';
export var ApiTokenActionColumnView = function ApiTokenActionColumnView(props) {
  return /*#__PURE__*/React.createElement(Button, {
    size: "small",
    onClick: props.onRevokeClick
  }, "Revoke");
};